// keep this import at first line
import { loadPolyfills } from './polyfill-loader';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import { configureLocale, setLocale } from '@tmapy/intl';
import { ErrorPage } from '@tmapy/style-guide';

import reportWebVitals from './reportWebVitals';

import { sentryInit } from './sentry';
import { configureStore } from './redux/configureStore';
import { loadLocale } from './locale/loadLocale';
import { ENDPOINT_APP_DATA, ENDPOINT_CATALOG_DATA, QUERY_STATE, VERSION } from './constants';
import { App } from './app/App';
import { actionLoadData, actionSetEndpointQuery } from './actions';

console.log('version: ', VERSION);

// priprava pro React 18
// let reactRoot: ReactDOM.Root | null = null;
// const getReactRoot = () => {
//   if (reactRoot) return reactRoot;
//   reactRoot = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
//   return reactRoot;
// };

async function main() {
  const rootElement = document.getElementById('root');
  try {
    await loadPolyfills();

    sentryInit();

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    if (process.env.NODE_ENV === 'development') {
      reportWebVitals(console.log);
    }

    Sentry.setTag('application', 'EDAS');

    const store = configureStore();

    await store.dispatch(actionLoadData({ endpoint: ENDPOINT_APP_DATA }) as any);
    const state = store.getState();
    if (state.edas.appData.queryState !== QUERY_STATE.SUCCESS) {
      throw new Error('Cannot load application configuration :(');
    }

    Sentry.setTag('lang', state.edas.appData.data.config.lang);
    Sentry.setTag('city', state.edas.appData.data.config.city);
    Sentry.setUser({ username: state.edas.appData.data.user });

    store.dispatch(
      configureLocale({
        loader: loadLocale,
        supported: [state.edas.appData.data.config.lang ?? 'cs'],
      }),
    );

    const locale = store.getState()?.intl?.currentLocale;
    store.dispatch(setLocale(locale) as any);

    if (!window.location.search) {
      const initFilter = state.edas.appData.data.config.initFilter;
      const query: Record<string, string | string[]> = {};
      for (const [key, value] of Object.entries(initFilter)) {
        query[key] = Array.isArray(value) ? value.map((val) => `${val}`) : `${value}`;
      }
      store.dispatch(actionSetEndpointQuery({ endpoint: ENDPOINT_CATALOG_DATA, query }) as any);
    }

    const app = (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    ReactDOM.render(app, rootElement);
  } catch (error) {
    console.error('Error while rendering app', error);
    ReactDOM.render(<ErrorPage title='Jejda!' subtitle={(error as Error)?.message} />, rootElement);
  }
}

main();
